// extracted by mini-css-extract-plugin
export default {"widthInput":"form-section-emergency_widthInput__gkpTs"};